// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"49bf6338","239":"de62f76b","453":"a7c28b50","667":"65854ce0"}[chunkId] + ".chunk.js";
};